import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import config from '../../../../config';
import PrescriptionForm from './PrescriptionForm';

let $ = window.jQuery;
let App = window.App;

export default class Prescription extends Component {
    state = {
        data: [],
        isLoaded: false
    };

    handlePrescriptionPreview = (e) => {
        let timestamp = e.target.dataset.timestamp;
        let patientId = this.props.patientId;
        let session = localStorage.getItem('token');

        let url = `${config.apiUrl}patients/${patientId}/prescriptions/pdf/${timestamp}?access_token=${session}`;

        $('#prescriptionPDF').find('iframe').prop('src', url);
        $('#prescriptionPDF').modal('show');
    };

    getPrescriptions = () => {
        App.blockUI({
            target: 'body',
            boxed: true
        });

        let url = `${config.apiUrl}patients/${this.props.patientId}/prescriptions`;

        axios.get(url).then((res) => {
            let data = [];
            for (let item of Object.keys(res.data.data)) {
                let tmp = {
                    name: moment(item*1000).format('MMM DD, YYYY'),
                    action: '<i class="fa fa-print prescription-preview" data-timestamp='+item+' style="cursor: pointer"></i>',
                    data: res.data.data[item]
                };

                data.push(tmp);
            }

            this.addRowsToTable(data);
            this.setState({
                data,
                isLoaded: true
            });

            App.unblockUI('body');
        });
    };

    /* Formatting function for row details - modify as you need */
    format  = ( d ) => {
        console.log('row data: ', d);
        // `d` is the original data object for the row
        let html = '<table cellpadding="5" cellspacing="0" class="table table-bordered" border="0" style="padding-left: 50px; width: 100%">'+
                '<thead>'+
                    '<tr>'+
                        '<th>Medication</th>'+
                        '<th>Quantity</th>'+
                        '<th>Sig.</th>'+
                    '</tr>'+
                '</thead>'+
                '<tbody>';

        for (let prescription of d.data) {
            html += '<tr>'+
                        '<td>'+prescription.medicine+'</td>'+
                        '<td>'+prescription.qty+'</td>'+
                        '<td>'+prescription.sig+'</td>'+
                    '</tr>';
        }

        html +=  '</tbody>';

        html +=  '</table>';


        return html;
    };

    addRowsToTable = (data) => {
        // eslint-disable-next-line
        let prescriptionTable = $('#prescriptionTable').DataTable();

        prescriptionTable.clear();
        for (let item of data) {
            prescriptionTable.row.add(item);
        }

        prescriptionTable.draw();
    };

    initializeTable = () => {
        // eslint-disable-next-line
        let prescriptionTable = $('#prescriptionTable').DataTable( {
            "data": this.state.data,
            "columns": [
                {
                    "className":      'details-control',
                    "orderable":      false,
                    "data":           null,
                    "defaultContent": ''
                },
                { "data": "name" },
                { "data": "action"}
            ],
            "order": [[1, 'asc']],
            "destroy": true
        } );

        let self = this;
        // Add event listener for opening and closing details
        $('#prescriptionTable tbody').on('click', 'td.details-control', function () {
            var tr = $(this).closest('tr');
            var row = prescriptionTable.row( tr );

            if ( row.child.isShown() ) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(self.format(row.data())).show();
                tr.addClass('shown');
            }
        });

        $(document).on('click', '.prescription-preview', (e) => {
            this.handlePrescriptionPreview(e);
        });
    };

    componentDidMount() {

        // if(sessionStorage.getItem('lastTab') == 'prescriptionPage')
        // {
        //     this.getPrescriptions();
        // }

        $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {

            let target = e.target.href.split('#');
            let index = target.findIndex((item) => {
                return item === 'prescriptionPage'
            });

            if (index >= 0 && !this.state.isLoaded) {
                this.initializeTable();
                this.getPrescriptions();
            }
        });
    }

    render() {
        return (
            <div>
                <table id="prescriptionTable" className="table table-striped table-bordered table-hover" cellSpacing="0" width="100%">
                    <thead>
                    <tr>
                        <th/>
                        <th>Prescription Date</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                </table>

                <PrescriptionForm patientId={this.props.patientId} getPrescriptions={this.getPrescriptions}/>

                <div id="prescriptionPDF" data-width="900" className="modal fade in"
                     tabIndex="-1" aria-hidden="true" data-backdrop="static" data-keyboard="false">

                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={this.handleClosePrescriptionPDFPreview}
                                    data-dismiss="modal" aria-hidden="true" />
                            <h4 className="modal-title">Prescription</h4>
                        </div>
                        <div className="modal-body">
                            <iframe style={{ width: '100%', height: '500px'}}></iframe>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}


/** WEBPACK FOOTER **
 ** ./src/components/patient/Prescription/Prescription.js
 **/